import { API } from '../api/api'
import { fetch, post } from '../api/httpClient'
import { DATEFORMATWITHTIME, REVIEW_SETTING_BOOLEAN_KEYS } from '../helpers/constants'
import { formatDate, get, isEmpty, isNullOrEmpty } from '../helpers/utils'

export const updateReviewSettingsCall = (payload, successCallback, failureCallback) => async () => {
  try {
    await post(API.CORE.METADATA, payload)

    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
export const getReviewsListCall = (params, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.RATING_REVIEW.RATING_REVIEW}?context_type=${params.context_type}&context_id=${params.context_id}`
    let { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const getProgramRatingListCall = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.ENROLLMENT_RATING_LIST}/${id}`
    let { data } = await fetch(url)

    const enrollmentData = get(data, 'enrollment', [])
    if (Array.isArray(enrollmentData)) {
      enrollmentData.forEach((item) => modifyProgramCompleted(item))
    }
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const getCoursesRatingListCall = (id, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.COURSES_RATING_LIST}/${id}`
    let { data } = await fetch(url)

    const coursesData = get(data, 'courseRatingListing', [])
    if (Array.isArray(coursesData)) {
      coursesData.forEach((item) => modifyCoursesCompleted(item))
    }
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchPublicRatingReviewStatus =
  (params, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.RATING_REVIEW.RATING_REVIEW}/api/public-config-data?${params}`

      let { data } = await fetch(url)

      const transformedData = data.map((item) => {
        const contextDataObject = item.context_data.reduce((acc, { config_key, config_value }) => {
          acc[config_key] = convertToBoolean(config_value)
          return acc
        }, {})

        return {
          ...item,
          context_data: contextDataObject,
        }
      })

      if (typeof successCallback === 'function') {
        successCallback(transformedData)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchRatingReviewStatus =
  (params, context_id, successCallback, failureCallback) => async () => {
    try {
      let filterQuery = `${params}`
      // Object.keys(params).forEach((key, index) => {
      //   const value = params[key]
      //   filterQuery += `${key}=${encodeURIComponent(value)}`
      //   if (index < Object.keys(params).length - 1) {
      //     filterQuery += '&'
      //   }
      // })
      if (!isNullOrEmpty(context_id)) {
        filterQuery += `&sch_id=${context_id}`
      }
      const url = `${API.RATING_REVIEW.RATING_REVIEW}/api/student-rating-review/reviewed-check?${filterQuery}`

      let { data } = await fetch(url)

      let transformedData = []
      if (isNullOrEmpty(context_id)) {
        transformedData = data.map((item) => {
          const contextDataObject = item.context_data.reduce(
            (acc, { config_key, config_value }) => {
              acc[config_key] = convertToBoolean(config_value)
              return acc
            },
            {}
          )
          const isReviewed = convertToBoolean(item.isReviewed)

          return {
            ...item,
            context_data: contextDataObject,
            isReviewed: isReviewed,
          }
        })
      } else {
        const config_data = data[0].configData.reduce((acc, { config_key, config_value }) => {
          acc[config_key] = convertToBoolean(config_value)
          return acc
        }, {})
        transformedData = data[0].reviewedData.map((item) => ({
          ...item,
          configData: config_data,
        }))
      }

      if (typeof successCallback === 'function') {
        successCallback(transformedData)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchTicketRatingCall = (hdtId, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.RATING_REVIEW.RATING_REVIEW}/api/student-rating-review/helpdesk/${hdtId}`
    let { data } = await fetch(url)
    modifyAggregateRating(data)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchAggregateRatingsCall = (params, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.RATING_REVIEW.RATING_REVIEW}/api/student-rating-review/aggregate?${params}`
    let { data } = await fetch(url)
    data.forEach((item) => modifyAggregateRating(item))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
export const fetchPublicAggregateRatingsCall =
  (params, successCallback, failureCallback) => async () => {
    try {
      const url = `${API.RATING_REVIEW.RATING_REVIEW}/api/student-rating-review/public-aggregate?${params}`
      let { data } = await fetch(url)
      data?.length ? data.forEach((item) => modifyAggregateRating(item)) : []
      if (typeof successCallback === 'function') {
        successCallback(data)
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const rateReviewCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.RATING_REVIEW.CREATE_RATING_REVIEW}`
    const { data } = await post(url, payload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const publicRateReviewCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.RATING_REVIEW.CREATE_PUBLIC_RATING_REVIEW}`
    const { data } = await post(url, payload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchReviewSettingsCall = (params, successCallback, failureCallback) => async () => {
  try {
    const url = `${API.RATING_REVIEW.RATING_REVIEW}/api/student-config?context_type=${params.context_type}&context_id=${params.context_id}`
    let { data } = await fetch(url)
    data = data.reduce((value, currentItem) => {
      value[currentItem.config_key] = checkForTypes(
        currentItem.config_key,
        currentItem.config_value
      )
      return value
    }, {})
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

const modifyAggregateRating = (item) => {
  if (isEmpty(item)) {
    return
  }
  item.aggregateRating = item?.aggregateRating ? Number(item.aggregateRating).toFixed(1) : 0
  item.rating = item?.rating ? Number(item.rating) : 0
}

const checkForTypes = (key, value) => {
  if (REVIEW_SETTING_BOOLEAN_KEYS.includes(key)) {
    return value === '1'
  } else {
    return value
  }
}
const convertToBoolean = (value) => (value === '1' ? true : value === '0' ? false : value)

const modifyProgramCompleted = function (item) {
  if (isNullOrEmpty(item)) {
    return
  }
  item.updatedPgmTimeLabel = formatDate(item.latest_status_update_at, DATEFORMATWITHTIME)
}

const modifyCoursesCompleted = function (item) {
  if (isNullOrEmpty(item)) {
    return
  }
  item.updatedEncTimeLabel = formatDate(item.enc_mark_completed_on, DATEFORMATWITHTIME)
}
